export default __webpack_public_path__ + "static/media/joys550_wiring.7f3769ee.jpg";